var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalletLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9961 14C15.9961 14.8284 16.6677 15.5 17.4961 15.5C18.3245 15.5 18.9961 14.8284 18.9961 14C18.9961 13.1716 18.3245 12.5 17.4961 12.5C16.6677 12.5 15.9961 13.1716 15.9961 14Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99609 7H15.9961C18.8245 7 20.2387 7 21.1174 7.87868C21.9961 8.75736 21.9961 10.1716 21.9961 13V15C21.9961 17.8284 21.9961 19.2426 21.1174 20.1213C20.2387 21 18.8245 21 15.9961 21H9.99609C6.22486 21 4.33924 21 3.16767 19.8284C1.99609 18.6569 1.99609 16.7712 1.99609 13V11C1.99609 7.22876 1.99609 5.34315 3.16767 4.17157C4.33924 3 6.22486 3 9.99609 3H13.9961C14.9261 3 15.3911 3 15.7726 3.10222C16.8078 3.37962 17.6165 4.18827 17.8939 5.22354C17.9961 5.60504 17.9961 6.07003 17.9961 7",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletLight);
export default __webpack_public_path__ + "static/media/wallet-light.da33cc7413430fdb96986d62c659ae3f.svg";
export { ForwardRef as ReactComponent };